export function isIpAddress(hostname: string): boolean {
  return /^(\d{1,3}(\.\d{1,3}){3}|\[[0-9a-f:]+\])$/i.test(hostname);
}

export function rootDomain(hostname: string): string {
  if (isIpAddress(hostname)) return hostname;
  const parts = hostname.split(".");
  // For simple TLDs (e.g. api.tines.com → tines.com), take last 2 segments
  return parts.length > 2 ? parts.slice(-2).join(".") : hostname;
}

export function domainFromUrlPattern(urlPattern: string): string | null {
  // Strip common regex anchors and unescape dots: ^https://api\.tines\.com → https://api.tines.com
  const cleaned = urlPattern.replace(/^\^/, "").replaceAll("\\.", ".");
  try {
    return rootDomain(new URL(cleaned).hostname);
  } catch {
    return null;
  }
}

// TLD-ish labels that are never the service's name, so "api.sentry.io" and
// "foo.example.co.uk" both yield the label users know the product by.
const GENERIC_DOMAIN_LABELS = new Set(["co", "com", "net", "org", "ac", "gov"]);

export function domainSearchToken(targetUrl: string): string | undefined {
  let host: string;
  try {
    host = new URL(targetUrl).hostname;
  } catch {
    return undefined;
  }
  if (isIpAddress(host)) return undefined;
  const labels = host.split(".").filter(Boolean);
  if (labels.length < 2) return undefined;
  let token = labels[labels.length - 2]!;
  if (GENERIC_DOMAIN_LABELS.has(token) && labels.length >= 3) {
    token = labels[labels.length - 3]!;
  }
  return token.length >= 3 ? token : undefined;
}
